import { Plugin } from 'prosemirror-state';

import { AddMenuEmbed, Link2Outline } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import EmbedNodeView from './NodeView';

function plugins({ createReactNodeView, t, isMicroLearning }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          embed(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: EmbedNodeView,
              isMicroLearning,
            });
          },
        },
      },
    }),
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.embed.title') as string,
            description: t('Lygo:Menu.embed.description') as string,
            icon: Link2Outline,
            addMenuIcon: AddMenuEmbed,
            addMenuItemType: addMenuItemType.embeds,
            attrs: { href: null },
            searchWords: [
              'embeds',
              'pdf',
              'docs',
              'iframe',
              'google maps',
              'slides',
              'figma',
              'url',
            ],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
